import lscache from 'lscache';
import fx from 'money';
import CurrencyList from 'utils/CurrencyList';
import exchangeRates from 'utils/exchangeRates';

import currencyClient from '../flux/clients/currency';

fx.base = 'EUR';
fx.rates = exchangeRates;
const RATESKEY = 'RATES';
const BASEKEY = 'BASE';
const CACHEDURATION = 3 * 60; //minutes

const getCurrencies = () =>
  currencyClient.getCurrencies().then((json) => {
    fx.rates = json.rates;
    fx.base = json.base;
    lscache.set(RATESKEY, json.rates, CACHEDURATION);
    lscache.set(BASEKEY, json.base, CACHEDURATION);
  });

const ratesFromCache = lscache.get(RATESKEY);
if (
  ratesFromCache &&
  typeof ratesFromCache === 'object' &&
  !!ratesFromCache['EUR']
) {
  try {
    fx.rates = ratesFromCache;
    fx.base = lscache.get(BASEKEY) || 'EUR';
  } catch (e) {
    getCurrencies();
  }
} else {
  getCurrencies();
}

const isInteger = function (value) {
  return (
    typeof value === 'number' && isFinite(value) && Math.floor(value) === value
  );
};

const getNumberFormat = function (price, rounded) {
  const num = parseFloat(price);
  if (rounded) {
    return Math.ceil(num);
  }
  if (isFinite(num)) {
    if (isInteger(num)) {
      return num;
    }
    return num.toFixed(2);
  }

  return num;
};

const symbolsSuffix = {
  LKR: 'LKR',
  NPR: 'NPR',
  SGD: 'SGD',
};

const getPrettyPrice = function (
  priceInput: number,
  currencyCode = 'EUR',
  rounded = false,
): string {
  const price = priceInput > 0 ? priceInput : 0.0;
  const foundCurrency = CurrencyList.find((cur) => cur.code === currencyCode);
  const currency = foundCurrency ? foundCurrency.symbol_native : currencyCode;
  const symbol = symbolsSuffix[currencyCode] ? symbolsSuffix[currencyCode] : '';
  return currency + getNumberFormat(price, rounded) + symbol;
};

const getCurrencySymbol = function (currencyCode: string): string {
  const foundCurrency = CurrencyList.find((cur) => cur.code === currencyCode);
  return foundCurrency.symbol;
};

const getConvertedPrice = function (
  priceInput: number,
  currencyFrom = 'EUR',
  currencyTo = 'EUR',
): number {
  const price = priceInput > 0 ? priceInput : 0.0;
  if (currencyFrom === currencyTo) {
    return priceInput;
  }
  return fx.convert(price, { from: currencyFrom, to: currencyTo });
};

const getPrettyPriceFromOtherCurrency = function (
  value: number,
  currencyCode: string,
  otherCurrencyCode: string,
  round = false,
): string {
  const convertedPrice = getConvertedPrice(
    value,
    currencyCode,
    otherCurrencyCode,
  );
  return getPrettyPrice(convertedPrice, otherCurrencyCode, round);
};

export default {
  getPrettyPrice: getPrettyPrice,
  getConvertedPrice: getConvertedPrice,
  getPrettyPriceFromOtherCurrency: getPrettyPriceFromOtherCurrency,
  getCurrencySymbol: getCurrencySymbol,
};
